import {DefaultButton, DetailsList, Dropdown, IconButton, PrimaryButton, SelectionMode} from "@fluentui/react";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {Link, useOutletContext} from "react-router-dom";
import AppContent from "../Surfaces/AppContent";
import AuthContext from "../Services/AuthContext";
import AddVenture from "../Panel/Venture/AddVenture";
import AddVentureCredentials from "../Panel/Venture/AddVentureCredentials";
import {MoneyField} from "../Utilities/MoneyField";
import {CSVDownloader} from "react-papaparse";
import {ValueField} from "../Utilities/ValueField";
import {MoneyFormat} from "../Utilities/MoneyFormat";
import { formatBankAccountNumber } from "../Utilities/formatBankAccountNumber";
import { Stack } from '@fluentui/react';
import ventureStates  from '../Utilities/Const/ventureStates'
import { netGrossField, netGrossFieldName, useNetGross } from "../Utilities/NetGrossField";
import ImportVentureData from "../Panel/Venture/ImportVentureData";

function Dashboard(props) {
    const [user] = useContext(AuthContext);
    const netGross = useNetGross();
    const [columns, setColumns] = useState();
    const [companies, setCompanies] = useState([]);
    const [filter, setFilter] = useState(null);
    const [stateFilter, setStateFilter] = useState('all')
    const [ventures, setVentures] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const actions = useOutletContext();

    const [addVenture, setAddVenture] = useState(false);
    const [manageCredentials, setManageCredentials] = useState(false);
    const _choiceButtons = (item) => {
        if (item.id === filter) {
            return (<PrimaryButton key={item.id} onClick={() => setFilter(null)}>{item.name}</PrimaryButton>);
        }
        return (<DefaultButton key={item.id} onClick={() => setFilter(item.id)}>{item.name}</DefaultButton>);
    }
    useEffect(() => {
        setFilter(null);
        const abortController = new AbortController();
        async function fetchData() {
            await fetch("/api/venture", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setVentures(data); })
                .catch(err => { console.log(err) })
        }
        fetchData();
        async function fetchCompanies() {
            await fetch("/api/company", {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => { setCompanies(data) })
                .catch(err => { console.log(err) })
        }
        fetchCompanies();
        return () => abortController.abort();
    }, [refresh]);

    useEffect(() => {

            let results = [];
            let summarize = {
                'net_value': 0,
                'gross_value': 0,
                'current_net_value': 0,
                'current_gross_value': 0,
                'reserved_net_value': 0,
                'reserved_gross_value': 0,
                'free_net_value': 0,
                'free_gross_value': 0,
                'payments': 0,
                'outdate_payments': 0,
                'net_addons': 0,
                'gross_addons': 0
            };
            ventures.forEach((i) => {
               if ((i.company_id === filter || filter === null) && (stateFilter === 'all' || parseInt(stateFilter) === i.status )) {
                   results.push(i);
                   summarize = {
                       'net_value': summarize.net_value + parseFloat(i.net_value ?? 0),
                       'gross_value': summarize.gross_value + parseFloat(i.gross_value ?? 0),
                       'current_net_value': summarize.current_net_value + parseFloat(i.current_net_value ?? 0),
                       'current_gross_value': summarize.current_gross_value + parseFloat(i.current_gross_value ?? 0),
                       'reserved_net_value': summarize.reserved_net_value + parseFloat(i.reserved_net_value ?? 0),
                       'reserved_gross_value': summarize.reserved_gross_value + parseFloat(i.reserved_gross_value ?? 0),
                       'free_net_value': summarize.free_net_value + parseFloat(i.free_net_value ?? 0),
                       'free_gross_value': summarize.free_gross_value + parseFloat(i.free_gross_value ?? 0),
                       'payments': summarize.payments + parseFloat(i.payments ?? 0),
                       'outdate_payments': summarize.outdate_payments + parseFloat(i.outdate_payments ?? 0),
                       'net_addons': summarize.net_addons + parseFloat(i.net_addons ?? 0),
                       'gross_addons': summarize.gross_addons + parseFloat(i.gross_addons ?? 0),
                   };
               }
            });
        setColumns([
            {
                key: 'name',
                name: 'Kontrakt',
                ariaLabel: 'Nazwa utworzonego kontraktu',
                fieldName: 'name',
                minWidth: 225,
                isRowHeader: true,
                isResizable: true,
                onRender: (item) => (<Link to={`/venture/${item.id}`}><PrimaryButton text={item.name} /></Link>)
            },
            {
                key: 'projects',
                name: 'Proj',
                ariaLabel: 'Liczba projektów',
                fieldName: 'projects',
                minWidth: 35,
                isResizable: false,
            },
            {
                key: 'sold',
                name: 'Sprz',
                ariaLabel: 'Sprzedane',
                fieldName: 'sold',
                minWidth: 35,
                isResizable: false,
            },
            {
                key: 'reserved',
                name: 'Rez',
                ariaLabel: 'Rezerwacje',
                fieldName: 'reserved',
                minWidth: 35,
                isResizable: false,
            },
            {
                key: 'divider',
                name: 'Metraż',
                ariaLabel: 'Metraż',
                fieldName: 'divider',
                minWidth: 50,
                isResizable: false,
                ...ValueField()
            },
            {
                key: netGrossField(),
                name: (<>Wartość {netGrossFieldName()}
                    <span className={'total'}>{MoneyFormat(summarize[netGrossField()])}</span>
                </>),
                className: 'total-column',
                ariaLabel: 'Wartość kontraktu',
                fieldName: netGrossField(),
                minWidth: 100,
                isResizable: true,
                ...MoneyField()
            },
            {
                key: netGrossField('current_'),
                name: (<>Potwierdzone {netGrossFieldName()}
                    <span className={'total'}>{MoneyFormat(summarize[netGrossField('current_')])}</span>
                </>),
                className: 'total-column',
                ariaLabel: 'Potwierdzone',
                fieldName: netGrossField('current_'),
                minWidth: 100,
                isResizable: true,
                ...MoneyField()
            },
            {
                key: netGrossField('reserved_'),
                name: (<>Rezerwacje {netGrossFieldName()}
                    <span className={'total'}>{MoneyFormat(summarize[netGrossField('reserved_')])}</span>
                </>),
                className: 'total-column',
                ariaLabel: 'Rezerwacje',
                fieldName: netGrossField('reserved_'),
                minWidth: 100,
                isResizable: true,
                ...MoneyField()
            },
            {
                key: netGrossField('free_'),
                name: (<>Wolne {netGrossFieldName()}
                    <span className={'total'}>{MoneyFormat(summarize[netGrossField('free_')])}</span>
                </>),
                className: 'total-column',
                ariaLabel: 'Wolne',
                fieldName: netGrossField('free_'),
                minWidth: 100,
                isResizable: true,
                ...MoneyField()
            },
            {
                key: 'payments',
                name: (<>Opłacono
                    <span className={'total'}>{MoneyFormat(summarize.payments)}</span>
                </>),
                className: 'total-column',
                ariaLabel: 'Opłacono',
                fieldName: 'payments',
                minWidth: 100,
                isResizable: true,
                ...MoneyField()
            },
            {
                key: 'outdate_payments',
                name: (<>Opóźnione Płatności
                    <span className={'total'}>{MoneyFormat(summarize.outdate_payments)}</span>
                </>),
                className: 'total-column',
                ariaLabel: 'Wartość opóźnionych płatności',
                fieldName: 'outdate_payments',
                minWidth: 100,
                onColumnClick: () => alert(ventures.reduce((i, cv) => cv + i.outdate_payments, 0)),
                isResizable: true,
                ...MoneyField()
            },
            {
                key: netGrossField('', 'addons'),
                name: (<>Dodatki {netGrossFieldName()}
                    <span className={'total'}>{MoneyFormat(summarize[netGrossField('', 'addons')])}</span>
                </>),
                className: 'total-column',
                ariaLabel: 'Dodatki',
                fieldName: netGrossField('', 'addons'),
                minWidth: 100,
                isResizable: true,
                ...MoneyField()
            },
            {
                key: 'buffer_account',
                name: 'Numer Rachunku',
                ariaLabel: 'Numer rachunku powierniczego',
                fieldName: 'buffer_account',
                maxWidth: 210,
                isResizable: true,
                onRender: (item) => formatBankAccountNumber(item.buffer_account)
            },
            {
                key: 'credentials',
                name: 'Poświadczenia',
                ariaLabel: 'Poświadczenia do kontraktu',
                fieldName: 'credentials',
                minWidth: 40,
                isResizable: false,
                onRender: (item) => (
                    <IconButton iconProps={ {iconName: 'AuthenticatorApp' }} styles={ {'rootChecked': {'color': 'green', 'backgroundColor': 'transparent'}, root: {color: 'red'}}} title={item.credentials} checked={item.credentials !== null && item.credentials !== ''} onClick={() => setManageCredentials({venture_id: item.id, credentials: item.credentials})}/>
                )
            },
        ]);
            setFiltered(results);
    }, [filter, ventures, stateFilter, netGross]);
    const [importVentureData, setImportVentureData] = useState(false);

    useEffect(() => {
        actions([
            {
                key: 'addVenture',
                text: 'Dodaj Kontrakt',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddVenture(true)
            },
            {
                key: "importVentureData",
                text: "Import",
                iconProps: { iconName: "Upload" },
                onClick: () => setImportVentureData(true),
            },
        ]);
        return actions;
    }, []);

    const options = [
        { key: 'all', text: 'Wszystkie' },
        ...Object.entries(ventureStates).map(([key, value]) => ({ key, text: value }))
    ];

    return (
        <AppContent title={'Kontrakty'}>
            <Stack  horizontal disableShrink horizontalAlign="center" tokens={{childrenGap: 'l1'}}>
                <span>{companies.map(_choiceButtons)}</span>
                <Dropdown
                    selectedKey={stateFilter}
                    options={options}
                    styles={{dropdown: { width: 150 }}}
                    onChange={(e, selected) => setStateFilter(selected.key)}
                />
            </Stack>
            <DetailsList items={filtered} columns={columns} selectionMode={SelectionMode.none} className={'with-totals'}/>
            <CSVDownloader data={filtered} filename={`kontrakty`} bom={true} config={{delimiter: ';'}}><IconButton iconProps={ {iconName: 'ExcelDocument' }} title='Export CSV'/></CSVDownloader>
            <AddVenture edit={addVenture} dismissPanel={() => setAddVenture(false)} onSuccess={() => setRefresh(refresh + 1)}/>
            <AddVentureCredentials add={manageCredentials} dismissPanel={() => setManageCredentials(false)} onSuccess={() => setRefresh(refresh + 1)}/>
            <ImportVentureData data={importVentureData} endpoint={`/api/venture/csv_import`} dismissPanel={() => setImportVentureData(false)}
                               onSuccess={() => setRefresh(refresh + 1)} />
        </AppContent>
    );
}

export default Dashboard;